import { NavigationEnd, Router } from '@angular/router';
import { filter, map, shareReplay, startWith } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
/** Keep this in sync with ShellConfigTesting */
export class ShellConfig {
    constructor(router) {
        this.router = router;
    }
    getConfig(activatedRoute) {
        return this.router.events.pipe(filter(event => event instanceof NavigationEnd), map(() => activatedRoute.snapshot), startWith(activatedRoute.snapshot), map(snapshot => this.getRecursiveRouteData(snapshot)), shareReplay({ bufferSize: 1, refCount: true }));
    }
    /**
     * Get config from nested child routes.
     * Route data is specified in appropriate RoutingModules
     */
    getRecursiveRouteData(snapshot) {
        let { data } = snapshot;
        snapshot.children.forEach(child => {
            data = { ...data, ...this.getRecursiveRouteData(child) };
        });
        return data;
    }
}
ShellConfig.ɵfac = function ShellConfig_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ShellConfig)(i0.ɵɵinject(i1.Router)); };
ShellConfig.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ShellConfig, factory: ShellConfig.ɵfac, providedIn: 'root' });
